import cx from 'classnames';
import { CSSProperties } from 'react';

import s from './CircularLoader.module.css';

type Props = {
    className?: string;
    color?: string;
    thickness?: number;
    style?: CSSProperties;
};

export const CircularLoader = ({
    className,
    color = 'var(--ink-light)',
    thickness = 2,
    ...props
}: Props): JSX.Element => (
    <div className={cx(s.loader, className)} {...props}>
        <svg className={s.circular} viewBox="25 25 50 50">
            <circle
                className={s.path}
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke={color}
                strokeWidth={thickness}
                strokeMiterlimit="10"
            />
        </svg>
    </div>
);
